/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getGrowSummary} from '../api'

 export const useQueryGetGrowSummary = createReactQueryHook('getGrowSummary', getGrowSummary)
